import React, { useState, useEffect } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import { MutualFunds_Section } from "../../../Configuration/API_URL";
import { commaSeperator } from "../../../CommonMethhods/CovertRupees";
import Loader from "../../../Components/Common/Loader";
import { noDataFound } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axios from "axios";


export default function MFSection(props) {
    const clientCode = localStorage.getItem("clientCode")
    const storeToken = localStorage.getItem("ssoToken");
    const tradingToken = localStorage.getItem("tradingToken");
    const [loader, setLoader] = useState(false);
    const [mfData, setMfData] = useState({});
    const [filterVal, setFilterVal] = useState("absolute");

    const getMFData = async () => {
        setLoader(true);
        const payload = {
            userId: clientCode
        }

        try {
            const getBuisnessDetails = await axios.post(
                MutualFunds_Section.mfSnapshot, payload,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            let res = getBuisnessDetails?.data;
            if (res?.status === 0) {
                setMfData(res?.data?.info)
            } else {
                setMfData({});
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoader(false)
        }
    };

    useEffect(() => {
        getMFData()
    }, []);

    const handleTab = (type) => {
        setFilterVal(type)
    }

    console.log(mfData, "mfData");


    return (
        <>
            <div className="card-box bottom-25 mf-card-wrapper">
                <div className="card-title">
                    <h2>Investment Snapshot</h2>
                </div>
                <div className="mf-investment-card">
                    <div className="card-section">
                        <span className="title">Investment Amount</span>
                        <span className="values">₹{commaSeperator(mfData?.investmentSummary?.invAmt) || "0.00"}</span>
                    </div>
                    <div className="card-section">
                        <span className="title">Total Invested Amount</span>
                        <span className="values Open-value"
                        >
                            ₹{commaSeperator(mfData?.investmentSummary?.currVal) || "0.00"}
                        </span>
                    </div>
                    <div className="card-section">
                        <span className="title">Over P&L</span>
                        <span
                            className="values pending-value abs-return"
                        >
                            ₹{commaSeperator(mfData?.investmentSummary?.returns) || "0.00"}
                            <span
                                className={
                                    mfData?.investmentSummary?.absRet > 0
                                        ? "green-new-text values-mf"
                                        : mfData?.investmentSummary?.absRet < 0
                                            ? "red-new-txt values-mf"
                                            : "values-mf gray-text"
                                }
                            >
                                ({mfData?.investmentSummary?.absRet > 0 && "+"}
                                {commaSeperator(Math.abs(mfData?.investmentSummary?.absRet)) || "0.00"}%
                                )
                            </span>
                        </span>

                    </div>
                </div>
            </div>

            <div className={`${!mfData?.userFolios ? "col-12 col-lg-12 card-box bottom-25 mf-card-wrapper card-height" : "col-12 col-lg-12 card-box bottom-25 mf-card-wrapper"}`}>
                <div className="wrap-mf-inves">
                    <div className="card-title">
                        <h2>Investments</h2>
                    </div>
                    {mfData?.userFolios &&
                        <div className="filter-options">
                            <ul
                                className="nav nav-tabs filter-tabs"
                                id="knowledgeTab"
                                role="tablist"
                                onChange={() => handleTab()}
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${filterVal === "absolute" ? "active" : ""}`}
                                        id="video-tab"
                                        data-toggle="tab"
                                        data-target="#video-tab-pane"
                                        type="button"
                                        role="tab"
                                        aria-controls="video-tab-pane"
                                        aria-selected="false"
                                        onClick={() => handleTab("absolute")}
                                    >
                                        Absolute
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${filterVal === "XIRR" ? "active" : ""}`}
                                        id="module-tab"
                                        data-toggle="tab"
                                        data-target="#module-tab-pane"
                                        type="button"
                                        role="tab"
                                        aria-controls="module-tab-pane"
                                        aria-selected="true"
                                        onClick={() => handleTab("XIRR")}
                                    >
                                        XIRR
                                    </button>
                                </li>
                            </ul>
                        </div>
                    }
                </div>

                {loader ?
                    <div className="loader-alignment">
                        <Loader />
                    </div>
                    : mfData?.userFolios ?
                        mfData?.userFolios?.map((folio, i) =>
                            folio?.schemes?.map((scheme, j) => (
                                <div className="mf-invest-card bottom-25" key={j}>
                                    <div className="sch-wrap sch-name">
                                        <div className="wrap-logo">
                                            <img className="card-logo" src={scheme?.logo} alt="logo" /></div>

                                        <span className="card-sch-title">{scheme?.schName}</span>
                                    </div>

                                    <div className="card-section-wrap">
                                        <div className="card-section">
                                            <span className="title">Current</span>
                                            <span className="values-mf">₹{commaSeperator(scheme?.currVal)}</span>
                                        </div>
                                        <div className="card-section">
                                            <span className="title">Invested</span>
                                            <span className="values-mf">₹{commaSeperator(scheme?.invAmt)}</span>
                                        </div>
                                        <div className="card-section">
                                            <span className="title">Returns {filterVal === "absolute" && "(Chg%)"}</span>
                                            <span className="values-mf">{filterVal === "absolute" ?
                                                (
                                                    <span className="values-mf abs-return">
                                                        ₹{commaSeperator(scheme?.returns)}
                                                        <span
                                                            className={
                                                                scheme?.absRet > 0
                                                                    ? "green-new-text perc-val"
                                                                    : scheme?.absRet < 0
                                                                        ? "red-new-txt perc-val"
                                                                        : "perc-val gray-text"
                                                            }>
                                                            ({scheme?.absRet > 0 && "+"}
                                                            {scheme?.absRet}%)</span>
                                                    </span>
                                                ) : (
                                                    <span className={
                                                        scheme?.xirr > 0
                                                            ? "green-new-text"
                                                            : scheme?.xirr < 0
                                                                ? "red-new-txt"
                                                                : "values-mf"
                                                    }>
                                                        {scheme?.xirr}%
                                                    </span>
                                                )}</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) :
                        noDataFound()
                }
            </div>
        </>
    );
}
